import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="#0F0F0F"
      d="M45.047 27.121c-.946 0-1.885-.246-2.811-.744v4.215c0 .827-.146 1.404-.438 1.734-.291.33-.792.497-1.502.497h-1.391l-.166-.19V13.24l.166-.191h1.009c.966 0 1.64.45 2.018 1.348 1.037-1.046 2.295-1.57 3.77-1.57 1.473 0 2.648.635 3.468 1.912.82 1.276 1.23 3.026 1.23 5.244 0 1.102-.142 2.092-.422 2.975-.284.883-.666 1.63-1.147 2.243a5.086 5.086 0 0 1-1.691 1.419 4.536 4.536 0 0 1-2.09.497l-.003.004Zm-.328-11.372c-.981 0-1.809.477-2.483 1.431v6.39c.8.533 1.53.8 2.184.8.765 0 1.348-.39 1.746-1.17.398-.779.6-1.877.6-3.292 0-1.416-.19-2.481-.572-3.153-.383-.672-.875-1.006-1.475-1.006ZM64.674 13.541l-3.496 12.943c-.6 2.183-1.36 3.802-2.279 4.847-.918 1.046-2.298 1.571-4.135 1.571a8.663 8.663 0 0 1-2.976-.525c-.036-.405.015-.863.165-1.376.146-.513.335-.91.572-1.184.8.258 1.557.385 2.267.385 1.399 0 2.385-.934 2.948-2.807l.11-.358c-.69-.02-1.237-.147-1.64-.386-.401-.238-.681-.644-.847-1.212l-3.386-11.953c.741-.35 1.4-.525 1.979-.525.58 0 1.005.115 1.285.346.28.23.505.636.666 1.225l1.565 5.809c.11.421.375 1.698.797 3.83.015.126.098.19.248.19l2.688-11.154c.418-.11.947-.167 1.585-.167.639 0 1.218.092 1.747.275l.137.219v.007ZM66.26 14.866c.07-.33.22-.68.449-1.046.228-.366.46-.644.697-.827 1.475.183 2.484 1.01 3.032 2.477.69-1.634 1.845-2.449 3.465-2.449.6 0 1.147.064 1.64.19 0 1.285-.292 2.406-.875 3.36-.272-.09-.69-.154-1.258-.19-1.056 0-1.912.569-2.566 1.706v8.784a10.64 10.64 0 0 1-1.762.139 11.7 11.7 0 0 1-1.817-.14v-9.169c0-1.304-.335-2.25-1.01-2.835h.004ZM84.086 27.121c-.946 0-1.885-.246-2.811-.744v4.215c0 .827-.146 1.404-.438 1.734-.291.33-.792.497-1.502.497h-1.391l-.166-.19V13.24l.166-.191h1.01c.965 0 1.639.45 2.017 1.348 1.037-1.046 2.295-1.57 3.77-1.57 1.474 0 2.648.635 3.468 1.912.82 1.276 1.23 3.026 1.23 5.244 0 1.102-.142 2.092-.422 2.975-.283.883-.666 1.63-1.147 2.243a5.086 5.086 0 0 1-1.691 1.419 4.536 4.536 0 0 1-2.09.497l-.003.004Zm-.328-11.372c-.981 0-1.809.477-2.483 1.431v6.39c.8.533 1.53.8 2.184.8.765 0 1.348-.39 1.746-1.17.398-.779.6-1.877.6-3.292 0-1.416-.19-2.481-.572-3.153-.383-.672-.875-1.006-1.475-1.006ZM102.023 14.369c1.293 1.304 1.939 3.193 1.939 5.674 0 1.102-.138 2.1-.41 2.986-.272.891-.67 1.646-1.186 2.27a5.26 5.26 0 0 1-1.924 1.448c-.765.338-1.628.51-2.594.51s-1.825-.172-2.578-.51a5.236 5.236 0 0 1-1.912-1.447c-.52-.625-.915-1.38-1.187-2.27-.272-.891-.41-1.886-.41-2.987 0-2.223.529-3.98 1.585-5.272 1.056-1.293 2.558-1.94 4.506-1.94 1.71 0 3.102.512 4.179 1.542l-.008-.004Zm-4.179 1.157c-1.6 0-2.4 1.507-2.4 4.517 0 3.01.8 4.49 2.4 4.49 1.6 0 2.428-1.496 2.428-4.49s-.808-4.517-2.428-4.517ZM105.925 25.908c.016-.405.13-.847.343-1.336.209-.485.449-.867.725-1.141 1.439.791 2.704 1.185 3.796 1.185.6 0 1.088-.12 1.463-.358.374-.239.56-.56.56-.962 0-.645-.493-1.157-1.475-1.543l-1.529-.577c-2.295-.843-3.442-2.195-3.442-4.048 0-.66.123-1.252.367-1.777a3.87 3.87 0 0 1 1.037-1.348 4.685 4.685 0 0 1 1.596-.867c.619-.203 1.309-.302 2.074-.302.347 0 .733.028 1.159.084.426.055.859.135 1.297.234.437.1.855.215 1.257.346.399.127.745.266 1.037.414 0 .457-.091.934-.272 1.431-.181.497-.43.863-.737 1.102-1.439-.645-2.685-.963-3.741-.963-.473 0-.848.116-1.12.346a1.12 1.12 0 0 0-.41.895c0 .568.454 1.018 1.364 1.348l1.664.604c1.202.422 2.093 1.002 2.677 1.734.583.736.875 1.586.875 2.56 0 1.305-.481 2.347-1.447 3.126-.966.78-2.35 1.169-4.151 1.169-1.802 0-3.422-.45-4.967-1.348v-.008ZM129.704 21.2h-7.533c.055 1.01.288 1.806.698 2.382.409.577 1.123.867 2.144.867 1.021 0 2.267-.31 3.631-.934.528.548.863 1.276 1.009 2.174-1.455 1.046-3.205 1.571-5.243 1.571-1.928 0-3.39-.6-4.384-1.805-.993-1.2-1.486-2.986-1.486-5.356 0-1.102.126-2.096.382-2.986.257-.891.627-1.65 1.12-2.287a5.147 5.147 0 0 1 1.802-1.475c.709-.35 1.517-.525 2.428-.525s1.746.143 2.456.426a4.983 4.983 0 0 1 1.801 1.212c.493.525.86 1.142 1.104 1.857.245.716.367 1.495.367 2.342 0 .458-.028.895-.083 1.309-.055.413-.126.823-.217 1.224l.004.004Zm-5.27-5.781c-1.42 0-2.184 1.081-2.295 3.248h4.534v-.33c0-.882-.182-1.586-.544-2.119-.363-.533-.927-.8-1.692-.8h-.003Z"
    />
    <path
      fill="url(#a)"
      d="M19.927 6.265c-6.761 4.333-10.853 11.85-10.853 19.932V41.5l2.652-1.867c5.087-3.582 7.997-9.868 7.997-13.646l-.373-.32c-2.02-1.735-1.783-4.949.47-6.364 5.664-3.632 9.095-9.931 9.095-16.7V.5l-8.988 5.765Z"
    />
    <path
      fill="url(#b)"
      d="M19.524 27.949c.127-.543.199-1.962.199-1.962 0-8.081-3.973-15.389-10.734-19.726L0 .5v2.12c0 6.76 3.427 13.05 9.082 16.675l8.629 5.308s2.08 1.243 1.813 3.341v.005Z"
    />
    <g
      opacity={0.3}
    >
      <path
        fill="url(#c)"
        d="M19.927 6.265c-6.761 4.333-10.853 11.85-10.853 19.932V41.5l2.652-1.867c5.087-3.582 7.997-9.868 7.997-13.646l-.373-.32c-2.02-1.735-1.783-4.949.47-6.364 5.664-3.632 9.095-9.931 9.095-16.7V.5l-8.988 5.765Z"
      />
      <path
        fill="url(#d)"
        d="M19.524 27.949c.127-.543.199-1.962.199-1.962 0-8.081-3.973-15.389-10.734-19.726L0 .5v2.12c0 6.76 3.427 13.05 9.082 16.675l8.629 5.308s2.08 1.243 1.813 3.341v.005Z"
      />
    </g>
    <defs>
      <linearGradient
        id="a"
        x1={32.012}
        x2={2.371}
        y1={3.12}
        y2={36.282}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#81E0B2" />
        <stop offset={0.338} stopColor="#8EE896" />
        <stop offset={0.505} stopColor="#5EC968" />
        <stop offset={0.58} stopColor="#4DAC56" />
        <stop offset={0.733} stopColor="#7CE186" />
        <stop offset={1} stopColor="#99EBA1" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={5.702}
        x2={14.96}
        y1={18.137}
        y2={11.309}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#67D79A" />
        <stop offset={0.38} stopColor="#60D26C" />
        <stop offset={0.922} stopColor="#89E5A0" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={32.012}
        x2={2.371}
        y1={3.12}
        y2={36.282}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#81E0B2" />
        <stop offset={0.338} stopColor="#8EE896" />
        <stop offset={0.505} stopColor="#5EC968" />
        <stop offset={0.58} stopColor="#4DAC56" />
        <stop offset={0.733} stopColor="#7CE186" />
        <stop offset={1} stopColor="#99EBA1" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={5.702}
        x2={14.96}
        y1={18.137}
        y2={11.309}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#67D79A" />
        <stop offset={0.38} stopColor="#60D26C" />
        <stop offset={0.922} stopColor="#89E5A0" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
